var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatisticClickIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#F5F6F8",
    stroke: "#E4E5E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_908_14382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7191 36.3046L36.6416 35.227L34.9107 33.4991L37.7011 30.7087C38.0915 30.3176 38.091 29.6842 37.7 29.2937C37.5969 29.1909 37.4727 29.1117 37.3359 29.0618L28.3623 25.8062C27.323 25.4306 26.1759 25.9686 25.8003 27.0079C25.6415 27.4472 25.6414 27.9282 25.8 28.3675L29.0647 37.3411C29.1812 37.6624 29.4536 37.9019 29.7871 37.9765C29.8584 37.992 29.9312 37.9997 30.0042 37.9995C30.2695 37.9994 30.524 37.894 30.7116 37.7063L33.499 34.9109L35.2269 36.6388L36.3044 37.7164C36.7019 38.1002 37.3353 38.0892 37.7192 37.6917C38.0936 37.304 38.0936 36.6894 37.7192 36.3016L37.7191 36.3046Z",
    fill: "#898D9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0051 34.0103C18.4795 34.0103 14 29.5308 14 24.0052C14 18.4795 18.4795 14 24.0051 14C29.5307 14 34.0103 18.4795 34.0103 24.0052C34.0103 24.5577 33.5623 25.0056 33.0098 25.0056C32.4572 25.0056 32.0092 24.5577 32.0092 24.0052C32.0092 19.5846 28.4257 16.001 24.0051 16.001C19.5845 16.001 16.001 19.5846 16.001 24.0052C16.001 28.4257 19.5846 32.0093 24.0052 32.0093C24.5577 32.0093 25.0056 32.4572 25.0056 33.0098C25.0056 33.5623 24.5577 34.0103 24.0051 34.0103Z",
    fill: "#898D9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0882 29.6275C21.9567 29.6276 21.8265 29.6018 21.705 29.5515C18.6432 28.2798 17.192 24.7668 18.4636 21.705C19.7353 18.6431 23.2483 17.192 26.3101 18.4637C27.7797 19.074 28.9468 20.243 29.555 21.7135C29.7749 22.2204 29.5422 22.8096 29.0353 23.0295C28.5284 23.2494 27.9392 23.0167 27.7193 22.5099C27.7147 22.4993 27.7103 22.4886 27.7061 22.4779C26.8591 20.4363 24.5175 19.4679 22.4759 20.3149C20.4344 21.1619 19.466 23.5036 20.313 25.5451C20.7186 26.5228 21.4951 27.3 22.4724 27.7065C22.983 27.9178 23.2256 28.503 23.0143 29.0136C22.8593 29.3882 22.4936 29.6322 22.0882 29.6316L22.0882 29.6275Z",
    fill: "#898D9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_908_14382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticClickIcon);
export default __webpack_public_path__ + "static/media/statistic-click-icon.9db7b9503e3e0b111df57e6ba2383640.svg";
export { ForwardRef as ReactComponent };